module.exports = __webpack_public_path__ + "static/media/spot.e50ba8e5.svg";